import { enqueueSnackbar } from 'notistack';

export const successNotification = (message: string) => {
    enqueueSnackbar(message, { variant: 'success' });
};

export const errorNotification = (message: string) => {
    enqueueSnackbar(message, { variant: 'error' });
};
